(function () {
  if (window.__jm2DeferThirdParty) return;

  var LOOX_RE = /loox\.io|looxreviews|loox-reviews|loox_reviews/i;
  var FLEX_PAY_RE = /flex[-_]?pay|hsa[-_]?fsa|getflex\.com|flex-pay-with-hsa-fsa/i;
  var LATE_RE = /rebuyengine\.com|rechargecdn\.com|zdassets\.com|zendesk\.com|seel\.com|omnisnippet1\.com|soundestlink\.com|d2fk970j0emtue\.cloudfront\.net|elevate-ab-testing|elevateab\.app|ds0wlyksfn0sb\.cloudfront\.net/i;

  var pending = { loox: [], flexPay: [], late: [] };
  var flushed = { loox: false, flexPay: false, late: false };
  var loadedUrls = Object.create(null);
  var originalCreateElement = document.createElement.bind(document);
  var flexPayTriggerArmed = false;

  function classifyUrl(url) {
    if (!url) return null;
    if (LOOX_RE.test(url)) return 'loox';
    if (FLEX_PAY_RE.test(url)) return 'flexPay';
    if (LATE_RE.test(url)) return 'late';
    return null;
  }

  function copyScriptAttrs(from, to) {
    Array.prototype.forEach.call(from.attributes, function (attr) {
      if (attr.name === 'src' || attr.name === 'type' || attr.name === 'data-jm2-deferred' || attr.name === 'data-deferred-src' || attr.name === 'data-jm2-src' || attr.name === 'data-jm2-type') {
        return;
      }
      to.setAttribute(attr.name, attr.value);
    });
  }

  function isModuleTemplate(template) {
    if (!template) return false;
    if (template.getAttribute('data-jm2-type') === 'module') return true;
    return (template.getAttribute('type') || '').toLowerCase() === 'module';
  }

  function loadScript(src, template) {
    if (!src || loadedUrls[src]) return;
    loadedUrls[src] = true;

    var script = originalCreateElement('script');
    script.dataset.jm2Deferred = 'true';
    if (isModuleTemplate(template)) script.type = 'module';
    script.async = true;
    script.src = src;
    if (template) copyScriptAttrs(template, script);
    document.head.appendChild(script);
  }

  function insertStylesheet(src) {
    var link = originalCreateElement('link');
    link.rel = 'stylesheet';
    link.dataset.jm2Deferred = 'true';
    link.href = src;
    document.head.appendChild(link);
  }

  function queueUrl(kind, src, template, isStyle) {
    if (!src || loadedUrls[src]) return;

    if (flushed[kind]) {
      if (isStyle) {
        if (loadedUrls[src]) return;
        loadedUrls[src] = true;
        insertStylesheet(src);
        return;
      }
      loadScript(src, template);
      return;
    }

    pending[kind].push({
      src: src,
      template: template || null,
      isStyle: !!isStyle,
    });

    if (kind === 'flexPay' && flexPayTriggerArmed) {
      flush('flexPay');
    }
  }

  function flush(kind) {
    if (flushed[kind] || !pending[kind].length) return;
    flushed[kind] = true;

    pending[kind].forEach(function (item) {
      if (item.isStyle) {
        if (loadedUrls[item.src]) return;
        loadedUrls[item.src] = true;
        insertStylesheet(item.src);
        return;
      }

      loadScript(item.src, item.template);
    });

    pending[kind] = [];
  }

  function interceptScript(script) {
    if (!script || script.dataset.jm2Deferred === 'true') return false;

    var src = script.getAttribute('src');
    var kind = classifyUrl(src);
    if (!kind) return false;

    if ((script.getAttribute('type') || '').toLowerCase() === 'module') {
      script.setAttribute('data-jm2-type', 'module');
    }
    script.type = 'text/plain';
    script.dataset.jm2Deferred = 'true';
    script.dataset.deferredSrc = src;
    script.removeAttribute('src');
    queueUrl(kind, src, script);

    if (script.parentNode) {
      script.parentNode.removeChild(script);
    }

    return true;
  }

  function interceptStylesheet(link) {
    if (!link || link.dataset.jm2Deferred === 'true') return false;
    if ((link.getAttribute('rel') || '').toLowerCase().split(/\s+/).indexOf('stylesheet') === -1) return false;

    var href = link.getAttribute('href');
    var kind = classifyUrl(href);
    if (!kind) return false;

    link.dataset.jm2Deferred = 'true';
    link.dataset.deferredHref = href;
    link.removeAttribute('href');
    link.media = 'print';
    link.onload = null;
    queueUrl(kind, href, null, true);

    if (link.parentNode) {
      link.parentNode.removeChild(link);
    }

    return true;
  }

  function scheduleFlexPay() {
    flexPayTriggerArmed = true;

    var run = function () {
      flush('flexPay');
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: 2500 });
    } else {
      setTimeout(run, 1500);
    }

    setTimeout(run, 4000);
  }

  function scheduleLate() {
    var started = false;
    var run = function () {
      if (started) return;
      started = true;
      flush('late');
      flushed.late = true;
    };

    ['pointerdown', 'touchstart', 'scroll'].forEach(function (type) {
      window.addEventListener(type, run, { once: true, passive: true });
    });
    window.addEventListener('keydown', run, { once: true });
    setTimeout(run, 6000);
  }

  function scheduleLoox() {
    var run = function () {
      flush('loox');
    };

    var selectors = [
      '#MainContent > .shopify-section[id$="17580968656036ca9c"]',
      '#looxReviews',
      '[class*="loox"]',
      '[id*="loox"]',
    ];

    var target = null;
    for (var i = 0; i < selectors.length; i++) {
      target = document.querySelector(selectors[i]);
      if (target) break;
    }

    if (!target || !('IntersectionObserver' in window)) {
      window.addEventListener(
        'load',
        function () {
          if ('requestIdleCallback' in window) {
            requestIdleCallback(run, { timeout: 4000 });
          } else {
            setTimeout(run, 2500);
          }
        },
        { once: true }
      );
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        if (!entries.some(function (entry) {
          return entry.isIntersecting;
        })) {
          return;
        }
        observer.disconnect();
        run();
      },
      { rootMargin: '400px 0px', threshold: 0.01 }
    );

    observer.observe(target);
  }

  function interceptPreload(link) {
    if (!link || link.dataset.jm2Deferred === 'true') return false;
    if (link.getAttribute('rel') !== 'preload' || link.getAttribute('as') !== 'script') return false;

    var href = link.getAttribute('href');
    if (classifyUrl(href) !== 'late') return false;

    link.dataset.jm2Deferred = 'true';
    link.removeAttribute('href');
    if (link.parentNode) link.parentNode.removeChild(link);
    return true;
  }

  function queueLateMarkup(script) {
    if (!script || script.dataset.jm2Deferred === 'true') return;
    var src = script.getAttribute('data-jm2-src');
    if (!src) return;
    script.dataset.jm2Deferred = 'true';
    script.type = 'text/plain';
    queueUrl('late', src, script);
  }

  function scanHead() {
    document.querySelectorAll('head script[src]').forEach(interceptScript);
    document.querySelectorAll('head link[rel="stylesheet"][href]').forEach(interceptStylesheet);
    document.querySelectorAll('head link[rel="preload"][as="script"]').forEach(interceptPreload);
    document.querySelectorAll('head script[data-jm2-src]').forEach(queueLateMarkup);
  }

  function scanSubtree(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('script[src]').forEach(interceptScript);
    root.querySelectorAll('link[rel="stylesheet"][href]').forEach(interceptStylesheet);
    root.querySelectorAll('link[rel="preload"][as="script"]').forEach(interceptPreload);
    root.querySelectorAll('script[data-jm2-src]').forEach(queueLateMarkup);
  }

  document.createElement = function (tagName, options) {
    var element = originalCreateElement(tagName, options);
    var tag = tagName && String(tagName).toLowerCase();

    if (tag !== 'script') return element;

    var srcDescriptor = Object.getOwnPropertyDescriptor(HTMLScriptElement.prototype, 'src');
    if (!srcDescriptor || !srcDescriptor.set) return element;

    var nativeSet = srcDescriptor.set.bind(element);
    var nativeSetAttribute = element.setAttribute.bind(element);

    element.setAttribute = function (name, value) {
      if (name === 'src' && classifyUrl(value)) {
        element.dataset.jm2Deferred = 'true';
        element.dataset.deferredSrc = value;
        queueUrl(classifyUrl(value), value, element);
        return;
      }
      nativeSetAttribute(name, value);
    };

    Object.defineProperty(element, 'src', {
      configurable: true,
      enumerable: true,
      get: function () {
        return element.getAttribute('src') || element.dataset.deferredSrc || '';
      },
      set: function (value) {
        if (classifyUrl(value)) {
          element.dataset.jm2Deferred = 'true';
          element.dataset.deferredSrc = value;
          queueUrl(classifyUrl(value), value, element);
          return;
        }
        nativeSet(value);
      },
    });

    return element;
  };

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'SCRIPT') {
            interceptScript(node);
            return;
          } 
          if (node.tagName === 'LINK') {
            interceptStylesheet(node);
            interceptPreload(node);
            return;
          }
          scanSubtree(node);
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function boot() {
    scanHead();
    scanSubtree(document.body);
    scheduleFlexPay();
    scheduleLoox();
    scheduleLate();
  }

  window.__jm2DeferThirdParty = {
    scanHead: scanHead,
    boot: boot,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
